import MultiTouch from 'mapbox-gl-multitouch';
export default class Map {
    constructor() {
        this.selector = 'map';
        this.init();
    }

    init() {
        if ( typeof mapboxData !== "undefined" && mapboxData.hasOwnProperty( 'accessToken' ) ) {
            mapboxgl.accessToken = mapboxData.accessToken;

            let mapsElement = document.querySelectorAll( '[data-map]' );

            if( mapsElement.length < 1 ) {
                return;
            }

            const options = { 
                threshold: 0.5,
                rootMargin: '150%'
            }
    
            const observer = new IntersectionObserver( this.load, options);
            
            mapsElement.forEach( ( element ) => {
                observer.observe( element ); 
            } )
        }
    }

    load( entries, observer ) {
        entries.forEach( entry => {
            if ( entry.isIntersecting ) {
                let element = entry.target;
                let type = element.getAttribute( 'data-map' );

                let map = new mapboxgl.Map( {
                    container: element,
                    style: mapboxData.style,
                    center: [mapboxData.places[0].location.longitude, mapboxData.places[0].location.latitude],
                    zoom: 15,
                    attributionControl: false,
                    scrollZoom: false,
                    boxZoom: true
                } );

                map.addControl(new MultiTouch());

                mapboxData.places.forEach( ( place, i ) => {
                    if ( type === 'multi' || ( type === 'single' && i === 0 ) ) {
                        let markerEl = document.createElement('div');
                        markerEl.className = 'map__marker map__marker--' + place.type;

                        var markerInner = document.createElement('i');
                        markerInner.className = 'icon-' + place.type;

                        markerEl.appendChild( markerInner );

                        let marker = new mapboxgl.Marker(markerEl)
                            .setLngLat([place.location.longitude, place.location.latitude])
                            .addTo(map);

                        if( place.show_popup === true ) {
                            marker.setPopup(
                                new mapboxgl.Popup({ anchor: false, offset: 30, maxWidth: '260px', closeButton: false, closeOnMove: true })
                                    .setHTML( document.querySelector( '[data-popup="' + place.id + '"]' ).outerHTML )
                            )
                        }
                    }
                } );

                document.body.addEventListener( 'refresh-view', (e) => {
                    map.resize();
                } );

                window.addEventListener( 'popstate', (e) => {
                    map.resize();
                } );

                observer.unobserve( element );
            }
        } );
    }
}